import { useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useToast } from 'contexts';
import { recoverPassword } from 'services';

type RecoveryFormInputs = {
  username: string;
};

// A plataforma recusa em inglês; a tela precisa dizer o que o jogador pode fazer a respeito.
function describeRejection(message?: string) {
  if (message?.includes('does not have email')) {
    return 'Esta conta não tem e-mail cadastrado. Fale com o suporte para recuperar o acesso.';
  }

  return 'Não encontramos uma conta com esse e-mail.';
}

export default function RequestRecoveryCode({ onSuccess }: { onSuccess: (username: string) => void }) {
  const { toastify } = useToast();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<RecoveryFormInputs>();
  const [sending, setSending] = useState(false);

  const onSubmit: SubmitHandler<RecoveryFormInputs> = async data => {
    setSending(true);
    try {
      const { accepted, message } = await recoverPassword(data.username);

      if (!accepted) {
        toastify({ content: describeRejection(message), type: 'error' });
        return;
      }

      toastify({
        content: 'Código de recuperação enviado para o seu e-mail.',
        type: 'success',
      });
      onSuccess(data.username);
    } catch (error) {
      toastify({
        content: 'Erro ao enviar código de recuperação.',
        type: 'error',
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <ul>
        <li>
          <label htmlFor="username">Informe seu e-mail para receber o código de segurança.</label>
          <input
            type="text"
            id="username"
            {...register('username', { required: 'Campo obrigatório.' })}
            disabled={sending}
            placeholder="E-mail"
            className="mt-4"
          />
          {errors.username && <span role="alert">{String(errors.username.message)}</span>}
          <button type="submit" disabled={sending} className="py-2 px-4">
            Enviar
          </button>
        </li>
      </ul>
    </form>
  );
}
